import { useState } from 'react';
import { useFaqs } from '../hooks/usePublicContent';
import { Container } from '../components/ui/Container';
import { Eyebrow } from '../components/ui/Eyebrow';

export function FaqPage() {
  const { data: faqs, isLoading } = useFaqs();
  const [openId, setOpenId] = useState<number | null>(null);

  return (
    <Container className="py-16 md:py-24">
      <Eyebrow>Help</Eyebrow>
      <h1 className="mt-4 font-serif text-4xl font-light text-ink md:text-5xl">Frequently Asked Questions</h1>

      {isLoading && (
        <div className="mt-12 space-y-4">
          {[1, 2, 3].map((i) => (
            <div key={i} className="h-14 animate-pulse bg-stone-light/30" />
          ))}
        </div>
      )}

      {!isLoading && (!faqs || faqs.length === 0) && (
        <p className="mt-12 text-sm text-stone">No FAQs available yet.</p>
      )}

      {faqs && faqs.length > 0 && (
        <div className="mt-12 divide-y divide-stone-light border-y border-stone-light">
          {faqs.map((faq) => (
            <div key={faq.id}>
              <button
                type="button"
                className="flex w-full items-center justify-between py-5 text-left"
                onClick={() => setOpenId(openId === faq.id ? null : faq.id)}
              >
                <span className="pr-8 text-sm font-medium text-ink">{faq.question}</span>
                <span className="shrink-0 text-stone">{openId === faq.id ? '−' : '+'}</span>
              </button>
              {openId === faq.id && (
                <p className="pb-5 text-sm leading-relaxed text-stone">{faq.answer}</p>
              )}
            </div>
          ))}
        </div>
      )}
    </Container>
  );
}
